export const OAUTH_EVENT_IDENTIFIER = 'ats-integration-auth-callback';
export const PERMISSION_ERROR_MESSAGE = 'Insufficient permissions received from ATS';
export const OATH_POPUP_DIMENSIONS = {
  WIDTH: 500,
  HEIGHT: 600,
};
